<template>
	<div
		:style="css"
		class="headout">
		<div class="content">
			<div
				class="left pointer"
				@click="go('/')">
				<img
					:src="domainConfig.webIcon"
					alt="" />
				<div class="title">{{ domainConfig.webTitle }}</div>
			</div>
			<div class="right">
				<template v-if="isAuth">
					<div
						class="money pointer"
						@click="showMsg">
						<img
							src="@/assets/dia.png"
							alt="" />
						<div class="num">{{ userInfo?.coinsTotal }}</div>
					</div>
					<div
						class="avatar pointer"
						@click="$store.state.showCate = !showCate">
						<img
							:key="avatarUrl"
							:src="avatarUrl"
							:alt="avatar" />
					</div>
				</template>
				<div
					v-else
					class="login pointer"
					@click="goLogin">
					Login
				</div>
			</div>
		</div>
		<div
			v-show="showCate"
			class="category">
			<div class="ti">Account</div>
			<div class="email">
				<img
					:src="avatarUrl"
					alt="" />
				{{ userInfo?.email }}
			</div>
			<div
				class="box"
				@click="goto('myImages')">
				<img
					src="@/assets/p1.png"
					alt="" />
				<div class="t">My Images</div>
			</div>
			<el-divider></el-divider>
			<div class="ti">Resources</div>
			<div
				class="box"
				@click="gotoFeedBack">
				<img
					src="@/assets/p2.png"
					alt="" />
				<div class="t">Feedback</div>
			</div>
			<div
				class="box"
				@click="goto('terms-of-services')">
				<img
					src="@/assets/p3.png"
					alt="" />
				<div class="t">Terms of services</div>
			</div>
			<div
				class="box"
				@click="goto('privacy')">
				<img
					src="@/assets/p4.png"
					alt="" />
				<div class="t">Privacy policy</div>
			</div>
			<div
				class="box"
				@click="goto('disclaimer')">
				<img
					src="@/assets/p5.png"
					alt="" />
				<div class="t">Disclaimer</div>
			</div>
			<el-divider></el-divider>
			<div
				class="log pointer"
				@click="logout">
				Log Out
			</div>
		</div>
	</div>
</template>
<script>
import api from '../api'

export default {
	data() {
		return {}
	},
	computed: {
		avatarUrl() {
			return this.userInfo?.avatar
		},
		css() {
			return this.inTop
				? {
						background: 'transparent',
					}
				: {
						background: '#181818',
					}
		},
	},
	watch: {
		avatar() {
			setTimeout(() => {
				this.$forceUpdate()
			})
		},
	},
	mounted() {
		function debounce(func, wait) {
			let timeout
			return function (...args) {
				clearTimeout(timeout) // 清除上一次的定时器
				timeout = setTimeout(() => {
					func.apply(this, args) // 延迟执行函数
				}, wait)
			}
		}
		const cb = () => {
			let scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop
			if (scrollTop > 0) {
				this.$store.state.inTop = false
			} else {
				this.$store.state.inTop = true
			}
		}
		window.onscroll = debounce(cb, 10)
	},
	methods: {
		showMsg() {
			window.open("https://aitopupex.com/products/recharge-your-creativity-with-pixel-ai-lab", "_blank");
			// this.$message({
			// 	message: 'The page is under construction, launching soon.',
			// 	type: 'success',
			// 	duration: 3000,
			// })
		},
		gotoFeedBack() {
			window.open('https://forms.gle/Jfh2cL1kBhP4DtCG8', '_blank', 'resizable,scrollbars,status')
		},
		goto(where) {
			console.log(this.$route.path)
			this.$router.push({ name: where })
		},
		async logout() {
			const res = await api.logout()
			if (res == 200) {
				this.$cookies.remove('satoken')
				location.href = '/'
			}
		},
	},
}
</script>
<style lang="scss" scoped>
.headout {
	width: 100%;
	height: rem(80);
	position: fixed;
	z-index: 9999;
	// border-bottom: solid 1px #FFF;
	box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.18);
}
.content {
	margin: auto;
	height: 100%;
	display: flex;
	justify-content: space-between;
	.left {
		height: 100%;
		display: flex;
		align-items: center;
		img {
			width: rem(48);
		}
		.title {
			margin-left: rem(15);
			color: #fff;
			font-family: 'Bakbak One';
			font-size: rem(32);
			font-style: normal;
			font-weight: 400;
			line-height: rem(32); /* 100% */
		}
	}
	.right {
		height: 100%;
		display: flex;
		align-items: center;
		.login {
			color: #fff;
			font-family: 'Bakbak One';
			font-size: rem(24);
			font-style: normal;
			font-weight: 400;
			line-height: rem(24); /* 100% */
			font-size: rem(24);
			border-radius: rem(100);
			height: rem(48);
			line-height: rem(48);
			width: rem(150);
			text-align: center;
			background: linear-gradient(96deg, #3CCA7C 0%, #28C5C2 100%);
		}
		.money {
			align-items: center;
			padding: rem(10) rem(20);
			display: flex;
			height: rem(48);
			border-radius: rem(100);
			border: rem(1) solid rgba(255, 255, 255, 0.1);
			background: rgba(255, 255, 255, 0.06);
			margin-right: rem(24);
			.num {
				color: #fff;
				font-family: Roboto;
				font-size: rem(24);
				font-style: normal;
				font-weight: 900;
				line-height: rem(24); /* 100% */
			}
			img {
				margin-right: rem(10);
				width: rem(36);
			}
		}
		.avatar {
			display: flex;
			align-items: center;
			overflow: hidden;
			img {
				width: 100%;
				height: 100%;
			}
			width: rem(48);
			height: rem(48);
			flex-shrink: 0;
			border-radius: rem(24);
			background-color: #fff;
		}
	}
}
@media screen and (orientation: portrait) {
	.headout {
		height: rem(120);
		.content {
			width: 100%;
			padding: rem(30);
			.left {
				img {
					width: rem(60);
					height: rem(60);
				}
				.title {
					font-size: rem(40) !important;
				}
			}
		}
		.category {
			padding: rem(30);
			right: 2%;
			width: rem(550);
			height: rem(942);
			.ti {
				font-size: rem(36);
				font-style: normal;
				font-weight: 400;
				line-height: rem(36); /* 100% */
			}
			.email {
				margin-top: rem(20);
				margin-bottom: rem(20);
				color: #fff;
				font-family: Roboto;
				font-size: rem(28);
				font-style: normal;
				font-weight: 400;
				line-height: rem(28); /* 100% */
				display: flex;
				align-items: center;
				img {
					width: rem(52);
					height: rem(52);
					border-radius: rem(16);
					margin-right: rem(20);
				}
				padding: rem(18) rem(22);
				width: 100%;
				height: rem(88);
				flex-shrink: 0;
				border-radius: rem(22);
				border: rem(2) solid #525252;
				background: #2f2f2f;
				box-shadow: rem(0) rem(4) rem(15) rem(0) rgba(0, 0, 0, 0.1);
			}
			.box {
				cursor: pointer;
				.t {
					color: #fff;
					font-family: Roboto;
					font-size: rem(28);
					font-style: normal;
					font-weight: 400;
					line-height: rem(28); /* 100% */
				}
				width: rem(490);
				height: rem(88);
				margin-bottom: rem(20);
				padding: rem(18) rem(20);
				display: flex;
				align-items: center;
				img {
					width: rem(52);
					height: rem(52);
					border-radius: rem(16);
					margin-right: rem(20);
				}
				.ti {
					color: #fff;
					font-family: Roboto;
					font-size: rem(28);
					font-style: normal;
					font-weight: 400;
					line-height: rem(28); /* 100% */
				}
			}
			.log {
				font-size: rem(32);
				line-height: rem(62);
			}
		}
	}
}
@media screen and (orientation: landscape) {
	.content {
		width: 75vw;
	}
}
.category {
	z-index: 9999;
	position: absolute;
	right: 10%;
	width: rem(370);
	// height: rem(624);
	flex-shrink: 0;
	padding: rem(20);
	border-radius: rem(20);
	border: rem(1) solid #525252;
	background: #181818;
	box-shadow: rem(0) rem(4) rem(8) rem(0) rgba(0, 0, 0, 0.3);
	.ti {
		margin-bottom: rem(20);
		color: #fff;
		font-family: 'Bakbak One';
		font-size: rem(20);
		font-style: normal;
		font-weight: 400;
		line-height: rem(20); /* 100% */
	}
	.email {
		margin-top: rem(20);
		margin-bottom: rem(20);
		color: #fff;
		font-family: Roboto;
		font-size: rem(18);
		font-style: normal;
		font-weight: 400;
		line-height: rem(18); /* 100% */
		display: flex;
		align-items: center;
		img {
			width: rem(32);
			height: rem(32);
			border-radius: rem(16);
			margin-right: rem(20);
		}
		padding: rem(14) rem(20);
		width: rem(330);
		height: rem(60);
		flex-shrink: 0;
		border-radius: rem(16);
		border: rem(2) solid #525252;
		background: #2f2f2f;
		box-shadow: rem(0) rem(4) rem(15) rem(0) rgba(0, 0, 0, 0.1);
	}
	.box {
		cursor: pointer;
		.t {
			color: #fff;
			font-family: Roboto;
			font-size: rem(18);
			font-style: normal;
			font-weight: 400;
			line-height: rem(18); /* 100% */
		}
		width: rem(330);
		height: rem(60);
		margin-bottom: rem(10);
		padding: rem(14) rem(20);
		display: flex;
		align-items: center;
		img {
			width: rem(32);
			height: rem(32);
			border-radius: rem(16);
			margin-right: rem(20);
		}
		.ti {
			color: #fff;
			font-family: Roboto;
			font-size: rem(18);
			font-style: normal;
			font-weight: 400;
			line-height: rem(18); /* 100% */
		}
	}
	.box:hover {
		cursor: pointer;
		border-radius: rem(16);
		border: rem(2) solid #525252;
		opacity: 0.2;
		background: #2f2f2f;
		box-shadow: rem(0) rem(4) rem(15) rem(0) rgba(0, 0, 0, 0.1);
	}
	.log {
		justify-content: center;
		margin: rem(20) 0;
		display: flex;
		align-items: center;
		text-align: center;
		font-family: Roboto;
		font-size: rem(18);
		font-style: normal;
		font-weight: 900;
		line-height: rem(20); /* 100% */
		background: linear-gradient(96deg, #3CCA7C 0%, #28C5C2 100%);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}
	.el-divider {
		margin-block: rem(20);
	}
}
</style>
